export default {
    meta: {
        title: '合同详情',
        isShowNav: true,
        activeMenu: '/contract',
        crumbs: {
            path: ['/contract'],
            name: ['合同管理'],
        },
    },
};
